import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import {Grid} from 'semantic-ui-react';
import {connect} from "react-redux";
import {openModalOtherSales} from "../../actions/ModalOtherSalesActions";
import DynamicTable from "../../components/extras/DynamicTable";
import OtherSaleDialog from "../../components/sale/OtherSaleDialog";
import GoToSale from "../../components/sale/GoToSale";
import {dynamicTableAddOrUpdate} from "../../actions/DynamicTableDataAction";
import SaleTotal from "../../components/sales/SaleTotal";
import DeliveryState from "../../components/sale/DeliveryState";

class _DeliveryState extends Component{
    render(){
        return <DeliveryState state={this.props.delivery_state} id={this.props.id} all_options={true}/>
    }
}

class CallCenter extends Component {
    
    constructor(props){
        super(props);
        this.state = {
            table_other_sales: {
                headers: ['Nº', 'Fecha', 'Cliente', 'Valor', 'Acciones'],
                name: 'Pedido',
                title: 'Call Center',
                has_actions: false,
                can_add: false,
                navigate: false,
                pagination: true,
                url: 'sales/call-center',
                values: ['id', 'date', 'billing_number', 'client', 'total', 'state'],
                id: 'table_other_sales',
                child_fields: [{client:'full_name'}],
                component_fields: [{state:GoToSale, total:SaleTotal, 'date': _DeliveryState}]
            }
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.other_sale_select && nextProps.other_sale_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.other_sale_select);
        }
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.openModalOtherSales({show:true, sale:null});
        }
    };

    render() {
        return (
            <Grid stackable>
                <Grid.Row columns={1}>
                    <Grid.Column>
                        <DynamicTable {...this.state.table_other_sales} callbackDynamicTable={this.callbackDynamicTable} />
                    </Grid.Column>
                </Grid.Row>
                <OtherSaleDialog location='open_box'/>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        other_sale_select: state.get('other_sale_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalOtherSales(modal){
            dispatch(openModalOtherSales(modal))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(CallCenter));


// WEBPACK FOOTER //
// ./src/containers/sale/CallCenter.js